export const PILLOW_PRODUCT_ID = 1;
export const PILLOW_NAME = "כרית ארגונומית";

export const PILLOW_COPY = {
  hook: "לילה אחרי לילה אתם מתהפכים, מחפשים את התנוחה הנכונה, ומתעוררים עם צוואר נוקשה?",
  intro: "הכירו את כרית Cervica - כרית שינה ארגונומית שיצרנו במיוחד כדי לשחרר מתח ולפזר לחץ באזור הצוואר והכתפיים לאורך כל הלילה.",
  shape: "העיצוב הגלי הייחודי שלה שומר על יישור נכון של עמוד השדרה, ומותאם לשינה על הגב ועל הצד.",
  material: "הכרית עשויה מחומר ויסקו איכותי שמתאים את עצמו לצורת הצוואר והראש, לתמיכה יציבה ונעימה.",
  result: "התוצאה? שינה עמוקה ורגועה יותר.",
  reviews: "לקוחות רבים כבר גילו את ההבדל ודירגו אותנו בחמישה כוכבים.",
  cta: "שדרגו את השינה שלכם עם כרית Cervica.",
  shipping: "משלוח מהיר עד הבית.",
};

export const PILLOW_DESCRIPTION = Object.values(PILLOW_COPY).join("\n\n");

// Refresh the legacy pillow label without renaming other products or later edits.
export function getProductName(product) {
  if (
    Number(product.product_id) === PILLOW_PRODUCT_ID &&
    (!product.name || /^(medical|midical)\s+pillow$/i.test(product.name.trim()))
  ) {
    return PILLOW_NAME;
  }

  return product.name;
}

export function getPillowDescription(product) {
  const description = product.description?.trim();

  if (
    !description ||
    /^Ergonomic medical pillow designed by a physiotherapist\.?$/i.test(description)
  ) {
    return PILLOW_DESCRIPTION;
  }

  return description;
}
